import { useQuery } from '@tanstack/react-query';
import { getAccountBannerConfig } from '../../api/statementAccount';
import { QUERY_KEYS } from '../../constants/queryKeys';
function useGetAccountBannerConfig({ loyaltyPlanId }: { loyaltyPlanId: string | undefined }) {
   return useQuery({
      queryKey: [QUERY_KEYS.GET_CONFIG_ACCOUNTSTATEMENT_BANNER, loyaltyPlanId],
      queryFn: () => getAccountBannerConfig({ loyaltyPlanId }),
      enabled: !!loyaltyPlanId,
   })
}
export { useGetAccountBannerConfig };
export default useGetAccountBannerConfig